import { ReactNode } from 'react';
import { MessageContent } from './message-content';
import { cn } from '../lib/utils';

export const FakeBotMessage = ({
  children,
  headless,
  className,
}: {
  children: ReactNode;
  headless?: boolean;
  offset?: boolean;
  className?: string;
}) => {
  if (headless) {
    return (
      <div>
        <MessageContent
          className={cn(
            'w-fit wrap-break-words rounded-2 bg-transparent px-0 py-0 text-left',
            className
          )}
          data-testid="message-content"
        >
          {children}
        </MessageContent>
      </div>
    );
  }

  return (
    <div
      className={cn('group/message w-full')}
      data-role="assistant"
      data-testid={`message-assistant`}
    >
      <div className="flex w-full flex-col items-start justify-start gap-2.5">
        <div className="flex flex-col min-w-0 grow gap-2.5 w-full">
          <MessageContent
            className="w-full wrap-break-words rounded-2 bg-transparent px-0 py-0 text-left"
            data-testid="message-content"
          >
            {children}
          </MessageContent>
        </div>
      </div>
    </div>
  );
};
